<template>
  <button
    v-if="showDebugButton"
    class="button is-small debug-button"
    title="Debug in SnapQL Debugger"
    @click="openExplorer">
    <span class="icon is-small">
      <i class="mdi mdi-code-tags" />
    </span>
  </button>
</template>
<script>

  export default {
    props: {
      filterKey: {
        type: String,
        required: true,
      },
      dataContext: {
        type: Object,
        required: true,
      },
      dashboardKey: {
        type: String,
        required: true,
      },
    },
    computed: {
      // See modules/SnapQLDebugButton.vue for why this reads the context
      // rather than the route, and why MANAGE_DASHBOARDS is checked here.
      showDebugButton () {
        return Boolean(this.dataContext.debug)
          && this.$hasPermission('MANAGE_DASHBOARDS')
      },
    },
    methods: {
      openExplorer () {
        const baseUrl = this.$env.VUE_APP_VUE_3_CLIENT_URL
        const companyId = this.$route.params.company_id
        const params = new URLSearchParams({
          report: this.dashboardKey,
          filter: this.filterKey,
        })
        const url = `${baseUrl}/company/${companyId}/tools/semantic_debug?${params.toString()}`
        window.open(url, '_blank')
      },
    },
  }
</script>
<style scoped lang="scss">
.debug-button {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
}
</style>
